export const getFileUpload = (state, uuid) => state.medias.fileUploads.get(uuid)

export const getFileUploadByMeta = (state, metaKey, metaData) =>
  state.medias.fileUploads.find(
    record => record.getIn(['meta', metaKey]) === metaData
  )
